import { useState, useEffect } from 'react';
import {
  Grid,
  Button,
  Typography,
  DialogContent,
  DialogActions,
  InputAdornment,
  IconButton,
  Stack,
} from '@mui/material';
import AlertDialog from '../alertDialog';

const textColor = '#212634';

const SuccessPrompt = (props) => {
  const {
    openDialog,
    setOpenDialog,
    successMessage,
    handleCancel,
    referralLoading,
  } = props;

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <AlertDialog
        title="Referral sent"
        open={openDialog}
        setOpen={handleClose}
      >
        <DialogContent sx={{ my: -1, width: { md: '25vw', sm: '100%' } }}>
          <Typography color={textColor} gutterBottom variant="body1">
            {successMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            size="large"
            variant="contained"
            fullWidth
            disabled={referralLoading}
            sx={{ width: '10rem', height: 40 }}
            onClick={() => {
              handleCancel();
            }}
          >
            Done
          </Button>
        </DialogActions>
      </AlertDialog>
    </>
  );
};

export default SuccessPrompt;
